import { rem } from 'polished'
import styled from 'styled-components'
import theme from 'styles/theme'
import { Body12, Title60 } from 'components/Typography'

export const Wrapper = styled.div`
  background: ${(props) => props.theme.colors.sagelight};
  margin: 0 auto;
  padding: 60px 40px 40px;
  text-align: center;
  ${theme.mediaQueries.large} {
    margin: 0 auto;
    max-width: 1180px;
    padding: 80px;
  }
`

export const Inner = styled.div`
  margin: 0 auto;
  max-width: 500px;

  ${theme.mediaQueries.large} {
    max-width: none;
  }
`

export const Headline = styled(Title60)`
  color: ${(props) => props.theme.colors.terciaryFont};
  ${theme.mediaQueries.mobile} {
    letter-spacing: -1px;
    line-height: 40px;
  }
`

export const Copy = styled.div`
  margin: 20px auto 0;
  max-width: 500px;
  text-align: inherit;
  color: ${(props) => props.theme.colors.alternativeFont};
  p {
    font-size: inherit;
  }
  h3,
  h2,
  h1 {
    color: ${(props) => props.theme.colors.alternativeFont};
  }
`

export const List = styled.ul`
  display: block;
  list-style: none outside none;
  margin: 30px auto 0;
  padding: 0 0 0 36px;
  text-align: initial;

  ${theme.mediaQueries.large} {
    columns: 2;
    column-gap: 50px;
    max-width: 550px;
    padding: 0;
  }
`

export const ListItem = styled.li`
  break-inside: avoid;
  display: block;
  margin: 12px 0;
  padding: 0 0 0 30px;
  position: relative;
  color: ${(props) => props.theme.colors.alternativeFont};

  ${theme.mediaQueries.large} {
    margin: 8px 0;
  }

  &::before {
    border: 1px solid ${(props) => props.theme.colors.secondaryFont};
    border-width: 0 0 1px 1px;
    content: '';
    display: inline-block;
    height: 5px;
    transform: rotate(-45deg);
    transform-origin: 0 0;
    width: 10px;
    position: absolute;
    top: 10px;
    left: 0px;
  }

  html[dir='rtl'] & {
    padding: 0 30px 0 0;

    &::before {
      left: auto;
      right: 0;
    }
  }
`

export const CtaRow = styled.div`
  margin-top: 32px;

  ${theme.mediaQueries.large} {
    margin-top: 46px;
  }

  .cta {
    padding: ${rem(20)};
    max-width: 350px;
    width: 100%;

    ${theme.mediaQueries.large} {
      max-width: 300px;
    }
  }
`

export const Notice = styled(Body12)`
  color: ${(props) => props.theme.colors.secondaryFont};
  margin: 0 0 20px;

  ${theme.mediaQueries.large} {
    margin-bottom: 30px;
  }
`
